import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateGoalRequest,
  GoalListPayload,
  GoalResource,
  QueryGoalsRequest,
  UpdateGoalRequest,
} from './goal-api.model';

export interface GoalApi {
  list(query: QueryGoalsRequest): Observable<GoalListPayload>;
  get(goalId: number): Observable<GoalResource>;
  create(body: CreateGoalRequest): Observable<GoalResource>;
  update(goalId: number, body: UpdateGoalRequest): Observable<GoalResource>;
  link(goalId: number, caseId: number): Observable<void>;
  unlink(goalId: number, caseId: number): Observable<void>;
}

export const GOAL_API = new InjectionToken<GoalApi>('GOAL_API');
